export default "__VITE_ASSET__ec9ab747__"